/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import EditIcon from "@material-ui/icons/Edit";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";

// core components
import styles from "assets/jss/material-dashboard-react/components/tableStyle.js";
import { blue, red } from "@material-ui/core/colors";

const useStyles = makeStyles(styles);

export default function CustomTable(props) {
  const classes = useStyles();
  const { tableHead, tableData, tableHeaderColor } = props;

  const handleClickUpdate = (event, id) => {
    onEdit(true, id);
  };

  const handleClickDelete = (event, id) => {
    onDelete(true, id);
  };

  function onEdit(e, id) {
    props.isEdit(e);
    props.select(id);
  }

  function onDelete(e, id) {
    props.isDelete(e);
    props.select(id);
  }

  return (
    <div className={classes.tableResponsive}>
      <Table className={classes.table}>
        {tableHead !== undefined ? (
          <TableHead className={classes[tableHeaderColor + "TableHeader"]}>
            <TableRow className={classes.tableHeadRow}>
              {tableHead.map((prop, key) => {
                return (
                  <TableCell
                    style={{ textAlign: "center" }}
                    className={classes.tableCell + " " + classes.tableHeadCell}
                    key={key}
                  >
                    {prop}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        ) : null}
        <TableBody>
          {tableData.slice().map((prop, key1) => {
            return (
              <TableRow
                key={key1}
                className={classes.tableBodyRow}
                style={{ cursor: "pointer" }}
                selected={true}
                hover={true}
                role="checkbox"
              >
                {tableData[key1][4] !== undefined
                  ? prop.slice(0, 3).map((prop, key) => {
                      return (
                        <TableCell
                          className={classes.tableCell}
                          key={key}
                          style={{ textAlign: "center" }}
                        >
                          <h6>
                            {prop !== "edit" && prop !== "delete" && prop}
                            {prop === "edit" && (
                              <EditIcon
                                style={{
                                  color: blue[500],
                                  fontSize: 30,
                                  cursor: "pointer"
                                }}
                                onClick={event =>
                                  handleClickUpdate(event, tableData[key1][4])
                                }
                              ></EditIcon>
                            )}
                            {prop === "delete" && (
                              <DeleteForeverIcon
                                onClick={event => handleClickDelete(event)}
                                style={{
                                  color: red[500],
                                  fontSize: 30,
                                  cursor: "pointer"
                                }}
                                // eslint-disable-next-line react/jsx-no-duplicate-props
                                onClick={event =>
                                  handleClickDelete(event, tableData[key1][4])
                                }
                              ></DeleteForeverIcon>
                            )}
                          </h6>
                        </TableCell>
                      );
                    })
                  : prop.slice(0, 2).map((prop, key) => {
                      return (
                        <TableCell
                          className={classes.tableCell}
                          key={key}
                          style={{ textAlign: "center" }}
                        >
                          <h6>
                            {prop !== "edit" && prop}
                            {prop === "edit" && (
                              <EditIcon
                                style={{
                                  color: blue[500],
                                  fontSize: 30,
                                  cursor: "pointer"
                                }}
                                onClick={event =>
                                  handleClickUpdate(event, tableData[key1][2])
                                }
                              ></EditIcon>
                            )}
                          </h6>
                        </TableCell>
                      );
                    })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}

CustomTable.defaultProps = {
  tableHeaderColor: "gray"
};

CustomTable.propTypes = {
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray"
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
  // tableSelect: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
};
